import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/class-assist/trademark-class/[classCode]/[item]/ClassAssistItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
